import firebase from 'firebase/app';
import 'firebase/database';
import {FIREBASE_CONFIG} from '../constants/FirebaseConfig';

// Initialize Firebase
let FIREBASEAPP = firebase.initializeApp(FIREBASE_CONFIG);

export default FIREBASEAPP;


// WEBPACK FOOTER //
// ./src/api/firebase.js